export default function ActiveFilters({ filters, setFilters }) {
	const { types, industryTerms, specieTerms, countyTerms } = filters;

	function isEmpty(array) {
		return array?.length < 1;
	}

	if (
		isEmpty(types) &&
		isEmpty(industryTerms) &&
		isEmpty(specieTerms) &&
		isEmpty(countyTerms)
	)
		return null;

	return (
		<div className="flex flex-wrap gap-1.5 mt-5 border-t-2 border-light-gray pt-5">
			<span className="font-bold text-xs mt-1 mr-0.5">
				Aktive filtre:
			</span>
			{types?.map((item, i) => (
				<FilterTag
					key={`${item.slug}_${i}`}
					filterType="Type"
					filterKey="types"
					item={item}
					filters={filters}
					setFilters={setFilters}
				/>
			))}
			{industryTerms?.map((item, i) => (
				<FilterTag
					key={`${item.slug}_${i}`}
					filterType="Næring"
					filterKey="industryTerms"
					item={item}
					filters={filters}
					setFilters={setFilters}
				/>
			))}
			{specieTerms?.map((item, i) => (
				<FilterTag
					key={`${item.slug}_${i}`}
					filterType="Art"
					filterKey="specieTerms"
					item={item}
					filters={filters}
					setFilters={setFilters}
				/>
			))}
			{countyTerms?.map((item, i) => (
				<FilterTag
					key={`${item.slug}_${i}`}
					filterType="Fylke"
					filterKey="countyTerms"
					item={item}
					filters={filters}
					setFilters={setFilters}
				/>
			))}
		</div>
	);
}

function FilterTag({ filterType, filterKey, item, filters, setFilters }) {
	function handleRemoveFilter(termItem) {
		// Remove item from filters
		// Also removes children from state when de-checking parent
		const newTermObjects = filters[filterKey].filter(
			term =>
				term.slug !== termItem.slug &&
				!termItem?.children?.nodes?.some(
					child => child.slug === term.slug
				)
		);
		setFilters(prev => ({
			...prev,
			[filterKey]: newTermObjects
		}));
	}

	return (
		<button
			onClick={() => handleRemoveFilter(item)}
			className="text-xs bg-light-gray rounded px-2 py-1 hover:bg-light-red transition-colors flex items-center"
		>
			{filterType}: {item.name}
			<i class="far fa-times ml-1.5"></i>
		</button>
	);
}
